import { component } from 'picoapp';
import { addVariant } from 'lib/cart';
import { image } from 'utils/image';
import OptionSelector from 'utils/option-selector';
import formatMoney from 'utils/format-money';

export default component(async (node, ctx) => {
  /**
   * Data + elements
   */
  const productData = JSON.parse(
    node.querySelector('.js-productData').innerHTML
  );
  const variantsData = JSON.parse(
    node.querySelector('.js-variantsData').innerHTML
  ).map((variant) => {
    const inventoryQuantity = parseInt(atob(variant.inventory_quantity), 10);
    const preorderLimit = variant.preorder_limit || 0;
    return {
      ...variant,
      inventory_quantity: inventoryQuantity,
      isPreorderState: variant.preorder && inventoryQuantity <= preorderLimit,
    };
  });
  const imageData = JSON.parse(node.querySelector('.js-imageData').innerHTML);

  const config = JSON.parse(node.dataset.config);
  const { colorOptionName, forceSoldOut, isGiftCard, sizeOptionName } = config;

  const strings = window.theme.strings.product;

  const imageWrapper = node.querySelector('.js-imageWrapper');
  const thumbsWrapper = node.querySelector('.js-thumbsWrapper');
  const form = node.querySelector('.js-form');
  const optionBtns = Array.from(node.querySelectorAll('.js-optionBtn'));
  const quantity = node.querySelector('.js-quantity');
  const addToCartBtn = node.querySelector('.js-addToCartBtn');
  const klaviyoBisTrigger = node.querySelector('.klaviyo-bis-trigger');
  const wishlistBtn = node.querySelector('.js-wishlistBtn');
  const price = node.querySelector('.js-price');
  const compareAtPrice = node.querySelector('.js-compareAtPrice');
  const variantSelect = node.querySelector('.js-variantSelect');
  const skuOutput = node.querySelector('.js-skuOutput');
  const currentColor = node.querySelector('.js-currentColor');
  const colorOutput = node.querySelector('.js-colorOutput');
  const availabilityDot = node.querySelector('.js-availabilityDot');
  const availabilityText = node.querySelector('.js-availabilityText');

  /**
   * Functions
   */
  const initThumbs = () => {
    const thumbs = thumbsWrapper.querySelectorAll('.js-thumb');

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const { type } = thumb.dataset;
        const details = JSON.parse(thumb.dataset.details);

        switch (type) {
          case 'image':
            imageWrapper.innerHTML = `${image(
              details,
              details.width / details.height
            )}`;
            break;

          case 'video':
            imageWrapper.innerHTML = `<video playsinline controls>
              ${details.sources.map(
                (source) =>
                  `<source src="${source.url}" type="${source.mimeType}">`
              )}
            </video>`;
            imageWrapper.querySelector('video').play();
            break;

          default:
            break;
        }
      });
    });
  };

  const updateImagesFromOption = ({ colorVal, sizeVal }) => {
    if (!colorVal || !sizeVal) return;

    const { images } = imageData;
    // eslint-disable-next-line max-len
    const first =
      images.find(
        (img) => img.color === colorVal && img.size.includes(sizeVal)
      ) || images.find((img) => img.color === colorVal);
    const rest = images.slice(images.indexOf(first) + 1, images.length);
    const next = rest.find((img) => img.color !== null);

    // eslint-disable-next-line max-len
    const imagesForColor = images.slice(
      images.indexOf(first),
      next ? images.indexOf(next) : images.length
    );
    const thumbs = thumbsWrapper.querySelectorAll('.js-thumb');

    thumbs.forEach((thumb) => {
      if (imagesForColor.map((i) => i.position).includes(+thumb.dataset.pos)) {
        thumb.classList.remove('!hidden');
      } else {
        thumb.classList.add('!hidden');
      }
    });

    imageWrapper.innerHTML = `${image(imagesForColor[0])}`;
  };

  const updateSelectionFromColor = ({ colorVal, sizeVal }) => {
    const variantsWithColor = productData.variants.filter(
      (variant) => variant[colorOptionName] === colorVal
    ); // eslint-disable-line

    optionBtns
      .filter((btn) => `option${btn.dataset.option}` === colorOptionName)
      .forEach((btn) => {
        if (btn.dataset.sizeValue === sizeVal) {
          btn.classList.remove('hidden');
        } else {
          btn.classList.add('hidden');
        }

        if (btn.dataset.value === colorVal) {
          btn.classList.add(btn.dataset.activeClass);
        } else {
          btn.classList.remove(btn.dataset.activeClass);
        }
      });

    const availableSizeVals = variantsWithColor
      .filter((variant) => variant.available)
      .map((variant) => variant[sizeOptionName]); // eslint-disable-line

    console.dir(availableSizeVals, { depth: null });

    optionBtns
      .filter((btn) => `option${btn.dataset.option}` === sizeOptionName)
      .forEach((btn) => {
        if (availableSizeVals.includes(btn.dataset.value) && !forceSoldOut) {
          btn.classList.remove(btn.dataset.disabledClass);
        } else {
          btn.classList.add(btn.dataset.disabledClass);
        }
      });

    // let sizeSettled = false;
    // optionBtns.filter((btn) => `option${ btn.dataset.option }` === sizeOptionName).forEach((btn) => {
    //   if (availableSizeVals.includes(btn.dataset.value) && !forceSoldOut) {
    //     btn.classList.remove(btn.dataset.disabledClass);
    //     // btn.disabled = false;
    //     // if (sizeSettled === false) {
    //     //   btn.click();
    //     //   sizeSettled = true;
    //     // } else {
    //     //   btn.classList.remove(btn.dataset.activeClass);
    //     // }
    //   } else {
    //     btn.classList.remove(btn.dataset.activeClass);
    //     btn.classList.add(btn.dataset.disabledClass);

    //     // select first available size
    //     if (sizeSettled === false) {
    //       const firstAvailableSize = availableSizeVals[0];
    //       const firstAvailableSizeBtn = optionBtns.find((b) => b.dataset.value === firstAvailableSize && b.dataset.option === sizeOptionName.replace('option', ''));

    //       if (!firstAvailableSizeBtn) return;

    //       firstAvailableSizeBtn.classList.remove(btn.dataset.disabledClass);
    //       firstAvailableSizeBtn.classList.add(btn.dataset.activeClass);

    //       firstAvailableSizeBtn.click();
    //       sizeSettled = true;
    //     }
    //   }
    // });
  };

  const initOptions = () => {
    const callback = (variant) => {
      if (isGiftCard) {
        return;
      }

      if (variant) {
        const variantData = variantsData.find((v) => v.id === variant.id);
        const preorderLabel = node.querySelector('[data-preorder-label]');
        const preorderTextContainer = node.querySelector(
          '[data-preorder-text-container]'
        );

        price.innerHTML = formatMoney(variant.price, theme.moneyFormat);

        if (variant.compare_at_price > variant.price) {
          compareAtPrice.hidden = false;
          compareAtPrice.innerHTML = formatMoney(
            variant.compare_at_price,
            theme.moneyFormat
          );
        } else {
          compareAtPrice.hidden = true;
        }

        skuOutput.textContent = variant.sku;

        if (currentColor) {
          currentColor.dataset.currentColor = variant[colorOptionName];
          currentColor.textContent = variant[colorOptionName];
        }

        if (colorOutput) {
          colorOutput.textContent = variant[colorOptionName];
        }

        if (variant.available && !forceSoldOut) {
          if (variantData.isPreorderState) {
            // available and preorder
            availabilityDot.classList.remove(
              availabilityDot.dataset.unavailableClass
            );
            availabilityDot.classList.remove(
              availabilityDot.dataset.availableClass
            );
            availabilityDot.classList.add(
              availabilityDot.dataset.preorderClass
            );
            availabilityText.textContent = strings.preorder;

            if (preorderLabel) {
              preorderLabel.hidden = false;
            }

            if (preorderTextContainer && variantData.preorder_text !== '') {
              preorderTextContainer.innerHTML = variantData.preorder_text;
              preorderTextContainer.hidden = false;
            }

            addToCartBtn.innerHTML = strings.preorder; // Using 'preorder' instead of 'preorderButton' as the latter was incorrect
          } else {
            // available but not preorder
            availabilityDot.classList.remove(
              availabilityDot.dataset.unavailableClass
            );
            availabilityDot.classList.remove(
              availabilityDot.dataset.preorderClass
            );
            availabilityDot.classList.add(
              availabilityDot.dataset.availableClass
            );
            availabilityText.textContent = strings.inStock;

            if (preorderLabel) {
              preorderLabel.hidden = true;
            }

            if (preorderTextContainer) {
              preorderTextContainer.hidden = true;
            }

            addToCartBtn.innerHTML = strings.addToCart;
          }

          addToCartBtn.disabled = false;
          addToCartBtn.classList.remove(addToCartBtn.dataset.disabledClass);
          addToCartBtn.classList.add(addToCartBtn.dataset.activeClass);
          addToCartBtn.classList.remove('hidden');
          klaviyoBisTrigger.style.display = 'none';
        } else {
          // not available at all
          availabilityDot.classList.add(
            availabilityDot.dataset.unavailableClass
          );
          availabilityDot.classList.remove(
            availabilityDot.dataset.preorderClass
          );
          availabilityDot.classList.remove(
            availabilityDot.dataset.availableClass
          );
          availabilityText.textContent = strings.soldOut;

          if (preorderLabel) {
            preorderLabel.hidden = true;
          }

          if (preorderTextContainer) {
            preorderTextContainer.hidden = true;
          }

          addToCartBtn.innerHTML = strings.soldOut;
          addToCartBtn.disabled = true;
          addToCartBtn.classList.remove(addToCartBtn.dataset.activeClass);
          addToCartBtn.classList.add(addToCartBtn.dataset.disabledClass);
          addToCartBtn.classList.add('hidden');
          klaviyoBisTrigger.style.display = 'block';
        }
      } else {
        addToCartBtn.innerHTML = strings.unavailable;
        addToCartBtn.disabled = true;
        addToCartBtn.classList.remove(addToCartBtn.dataset.activeClass);
        addToCartBtn.classList.add(addToCartBtn.dataset.disabledClass);
        addToCartBtn.classList.add('hidden');
        klaviyoBisTrigger.style.display = 'block';
      }
    };

    const optionSelector = OptionSelector(`#product-${productData.id}`, {
      data: productData,
      onVariantSelected: callback,
    });

    optionBtns.forEach((btn) => {
      const { option, value, activeClass } = btn.dataset;

      btn.addEventListener('click', () => {
        optionSelector.setOption(parseInt(option, 10) - 1, value);

        optionBtns
          .filter((otherBtn) => otherBtn.dataset.option === option)
          .forEach((otherBtn) => {
            otherBtn.classList[otherBtn === btn ? 'add' : 'remove'](
              activeClass
            );
          });

        if (option === colorOptionName.replace('option', '')) {
          const selectedSize = optionBtns.find(
            (b) =>
              b.dataset.option === sizeOptionName.replace('option', '') &&
              b.classList.contains(b.dataset.activeClass)
          ).dataset.value;

          updateSelectionFromColor({ colorVal: value, sizeVal: selectedSize });
          updateImagesFromOption({ colorVal: value, sizeVal: selectedSize });
        } else if (option === sizeOptionName.replace('option', '')) {
          const selectedColor = optionBtns.find(
            (b) =>
              b.dataset.option === colorOptionName.replace('option', '') &&
              b.classList.contains(b.dataset.activeClass)
          ).dataset.value;

          updateSelectionFromColor({ colorVal: selectedColor, sizeVal: value });
          updateImagesFromOption({ colorVal: selectedColor, sizeVal: value });
        }
      });

      if (option === colorOptionName.replace('option', '')) {
        btn.addEventListener('mouseenter', () => {
          currentColor.textContent = value;
        });

        btn.addEventListener('mouseleave', () => {
          currentColor.textContent = currentColor.dataset.currentColor;
        });
      }
    });
  };

  const initForm = () => {
    form.addEventListener('submit', (event) => {
      event.preventDefault();

      const variantId = parseInt(variantSelect.value, 10);
      const variantData = variantsData.find((v) => v.id === variantId);

      const {
        preorder: preorderPropertyKey,
        preorderTrue: preorderPropertyValue,
      } = window.theme.strings.product;

      const properties = variantData.isPreorderState
        ? { [preorderPropertyKey]: preorderPropertyValue }
        : {};

      addVariant({
        variantId,
        quantity: quantity?.value || 1,
        properties,
      });
    });
  };

  const initWishlist = () => {
    const wishlistEntry = window.Appmate.wk.getProduct(productData.id);
    let isInList;

    if (wishlistEntry !== null) {
      wishlistBtn.textContent = strings.removeFromFavorites;
      isInList = true;
    } else {
      isInList = false;
    }

    wishlistBtn.addEventListener('click', () => {
      window.Appmate.wk
        .toggleProduct(productData.id)
        .then(() => {
          isInList = !isInList;
          wishlistBtn.textContent = isInList
            ? strings.removeFromFavorites
            : strings.addToFavorites;
          ctx.emit('wishlist:updated');
        })
        .catch(console.error); // eslint-disable-line
    });
  };

  const init = () => {
    initOptions();
    initThumbs();
    initForm();

    if (window.Appmate?.wk?.getProduct) {
      initWishlist();
    } else {
      window.addEventListener('wishlistKing:loaded', initWishlist);
    }
  };

  /**
   * Init
   */
  init();
});

// Sticky add to cart button on mobile scrolls to variants if not in the viewport
const sizeVariants = document.querySelector('[data-size-variants]');
const stickyBuyButton = document.querySelector('[data-sticky-buy-button]');
const tickyBuyButtonBIS = document.querySelector('.klaviyo-bis-trigger');

function isButtonOutOfViewport() {
  const triggerRect = sizeVariants.getBoundingClientRect();
  return triggerRect.bottom < 0;
}

function footerReached() {
  const footer = document.querySelector('#shopify-section-footer');
  if (!footer) return false;
  const rect = footer.getBoundingClientRect();
  const isFooterReached = rect.top <= window.innerHeight;
  return isFooterReached;
}

function toggleHiddenButtonVisibility() {
  const width = window.innerWidth;

  if (footerReached() && width < 1024) {
    stickyBuyButton.style.transform = 'translateY(calc(100% + 32px))';
    stickyBuyButton.style.transition = 'transform 0.3s ease-in-out';
    tickyBuyButtonBIS.style.transform = 'translateY(calc(100% + 32px))';
    tickyBuyButtonBIS.style.transition = 'transform 0.3s ease-in-out';
  } else {
    stickyBuyButton.style.transform = 'translateY(0%)';
    stickyBuyButton.style.transition = 'transform 0.3s ease-in-out';
    tickyBuyButtonBIS.style.transform = 'translateY(0%)';
    tickyBuyButtonBIS.style.transition = 'transform 0.3s ease-in-out';
  }

  if (!sizeVariants) return;
  if (isButtonOutOfViewport() && width < 1024) {
    stickyBuyButton.type = 'button';
    stickyBuyButton.addEventListener('click', () => {
      sizeVariants.scrollIntoView({ block: 'center', behavior: 'smooth' });
    });
  } else {
    stickyBuyButton.type = 'submit';
  }
}

if (stickyBuyButton || tickyBuyButtonBIS) {
  window.addEventListener('scroll', toggleHiddenButtonVisibility);
  toggleHiddenButtonVisibility();
}
